"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsNullable = void 0;
const class_validator_1 = require("class-validator");
/**
 * If value is null it will skip all other validators.
 *
 * @example
 * class Example {
 *   @IsNullable()
 *   @IsNumber()
 *   public property: number | null;
 * }
 *
 * const example = new Example();
 * example.property = null; // is valid
 * example.property = 5; // is valid
 * example.property = undefined; // not valid
 */
const IsNullable = () => (target, key) => {
    (0, class_validator_1.ValidateIf)((object) => object[key] !== null)(target, key);
};
exports.IsNullable = IsNullable;
